// Loader type definitions and metadata
export const LOADER_TYPES = {
  RING: 'ring',
  PULSE: 'pulse',
  DOTS: 'dots',
  BARS: 'bars',
  WAVE: 'wave',
  SPINNER: 'spinner',
  PROGRESS_RING: 'progressRing',
  SKELETON: 'skeleton',
  BOUNCE: 'bounce',
  ROTATE: 'rotate',
  FADE: 'fade',
  SCALE: 'scale',
  RIPPLE: 'ripple',
  ORBIT: 'orbit',
  GRID: 'grid',
  LINES: 'lines',
  SHIMMER: 'shimmer',
  STAGGER: 'stagger',
  MORPH: 'morph',
  PARTICLE: 'particle',
};

export const LOADER_METADATA = {
  [LOADER_TYPES.RING]: {
    name: 'Ring',
    description: 'Rotating ring with gradient',
    defaultConfig: {
      style: LOADER_TYPES.RING,
      size: 50,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      strokeWidth: 4,
    },
    controls: ['size', 'speed', 'strokeWidth', 'primaryColor', 'secondaryColor'],
  },
  [LOADER_TYPES.PULSE]: {
    name: 'Pulse',
    description: 'Pulsing circle',
    defaultConfig: {
      style: LOADER_TYPES.PULSE,
      size: 50,
      minSize: 30,
      maxSize: 50,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'minSize', 'maxSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.DOTS]: {
    name: 'Dots',
    description: 'Pulsing dots with gradient support',
    defaultConfig: {
      style: LOADER_TYPES.DOTS,
      size: 50,
      dotCount: 3,
      minDotSize: 8,
      maxDotSize: 20,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'dotCount', 'minDotSize', 'maxDotSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.BARS]: {
    name: 'Bars',
    description: 'Horizontal bars animation',
    defaultConfig: {
      style: LOADER_TYPES.BARS,
      size: 50,
      barCount: 5,
      barWidth: 4,
      barHeight: 30,
      barSpacing: 4,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'barCount', 'barWidth', 'barHeight', 'barSpacing', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.WAVE]: {
    name: 'Wave',
    description: 'Wave-like loading animation',
    defaultConfig: {
      style: LOADER_TYPES.WAVE,
      size: 50,
      waveCount: 4,
      waveHeight: 20,
      waveWidth: 6,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'waveCount', 'waveHeight', 'waveWidth', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.SPINNER]: {
    name: 'Spinner',
    description: 'Classic spinner with multiple arms',
    defaultConfig: {
      style: LOADER_TYPES.SPINNER,
      size: 50,
      armCount: 8,
      armLength: 20,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'armCount', 'armLength', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.PROGRESS_RING]: {
    name: 'Progress Ring',
    description: 'Circular progress indicator',
    defaultConfig: {
      style: LOADER_TYPES.PROGRESS_RING,
      size: 50,
      progress: 0.7,
      strokeWidth: 4,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
    },
    controls: ['size', 'progress', 'strokeWidth', 'speed', 'primaryColor', 'secondaryColor'],
  },
  [LOADER_TYPES.SKELETON]: {
    name: 'Skeleton',
    description: 'Skeleton loading placeholders',
    defaultConfig: {
      style: LOADER_TYPES.SKELETON,
      size: 50,
      skeletonLineCount: 3,
      skeletonLineHeight: 12,
      skeletonLineSpacing: 8,
      primaryColor: '#e5e7eb',
      speed: 1.5,
    },
    controls: ['size', 'skeletonLineCount', 'skeletonLineHeight', 'skeletonLineSpacing', 'speed', 'primaryColor'],
  },
  [LOADER_TYPES.BOUNCE]: {
    name: 'Bounce',
    description: 'Bouncing dots/circles',
    defaultConfig: {
      style: LOADER_TYPES.BOUNCE,
      size: 50,
      dotCount: 3,
      dotSize: 12,
      bounceHeight: 20,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'dotCount', 'dotSize', 'bounceHeight', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.ROTATE]: {
    name: 'Rotate',
    description: 'Rotating elements',
    defaultConfig: {
      style: LOADER_TYPES.ROTATE,
      size: 50,
      elementCount: 6,
      elementSize: 8,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'elementCount', 'elementSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.FADE]: {
    name: 'Fade',
    description: 'Fading in/out elements',
    defaultConfig: {
      style: LOADER_TYPES.FADE,
      size: 50,
      elementCount: 4,
      elementSize: 12,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'elementCount', 'elementSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.SCALE]: {
    name: 'Scale',
    description: 'Scaling animation',
    defaultConfig: {
      style: LOADER_TYPES.SCALE,
      size: 50,
      elementCount: 3,
      minScale: 0.5,
      maxScale: 1.0,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'elementCount', 'minScale', 'maxScale', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.RIPPLE]: {
    name: 'Ripple',
    description: 'Ripple effect loader',
    defaultConfig: {
      style: LOADER_TYPES.RIPPLE,
      size: 50,
      rippleCount: 3,
      rippleWidth: 2,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.5,
      useGradient: false,
    },
    controls: ['size', 'rippleCount', 'rippleWidth', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.ORBIT]: {
    name: 'Orbit',
    description: 'Orbiting elements',
    defaultConfig: {
      style: LOADER_TYPES.ORBIT,
      size: 50,
      orbitCount: 3,
      orbitSize: 8,
      orbitRadius: 20,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'orbitCount', 'orbitSize', 'orbitRadius', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.GRID]: {
    name: 'Grid',
    description: 'Grid pattern loader',
    defaultConfig: {
      style: LOADER_TYPES.GRID,
      size: 50,
      gridRows: 3,
      gridCols: 3,
      cellSize: 10,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'gridRows', 'gridCols', 'cellSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.LINES]: {
    name: 'Lines',
    description: 'Animated lines',
    defaultConfig: {
      style: LOADER_TYPES.LINES,
      size: 50,
      lineCount: 5,
      lineWidth: 3,
      lineLength: 30,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'lineCount', 'lineWidth', 'lineLength', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.SHIMMER]: {
    name: 'Shimmer',
    description: 'Shimmer effect',
    defaultConfig: {
      style: LOADER_TYPES.SHIMMER,
      size: 50,
      width: 200,
      height: 20,
      primaryColor: '#e5e7eb',
      shimmerColor: '#ffffff',
      speed: 1.5,
    },
    controls: ['size', 'width', 'height', 'speed', 'primaryColor', 'shimmerColor'],
  },
  [LOADER_TYPES.STAGGER]: {
    name: 'Stagger',
    description: 'Staggered animation',
    defaultConfig: {
      style: LOADER_TYPES.STAGGER,
      size: 50,
      elementCount: 5,
      elementSize: 10,
      staggerDelay: 0.1,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.0,
      useGradient: false,
    },
    controls: ['size', 'elementCount', 'elementSize', 'staggerDelay', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.MORPH]: {
    name: 'Morph',
    description: 'Morphing shapes',
    defaultConfig: {
      style: LOADER_TYPES.MORPH,
      size: 50,
      shapeCount: 4,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 2.0,
      useGradient: false,
    },
    controls: ['size', 'shapeCount', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
  [LOADER_TYPES.PARTICLE]: {
    name: 'Particle',
    description: 'Particle effect loader',
    defaultConfig: {
      style: LOADER_TYPES.PARTICLE,
      size: 50,
      particleCount: 12,
      particleSize: 4,
      primaryColor: '#F26F29',
      secondaryColor: '#F03224',
      speed: 1.5,
      useGradient: false,
    },
    controls: ['size', 'particleCount', 'particleSize', 'speed', 'primaryColor', 'secondaryColor', 'useGradient'],
  },
};

// Get all loader types as array
export const getAllLoaderTypes = () => Object.values(LOADER_TYPES);

// Get loader metadata by type
export const getLoaderMetadata = (type) => LOADER_METADATA[type] || LOADER_METADATA[LOADER_TYPES.RING];
